import { z } from "zod";
import { CASE_SCHEMA } from "./Case";

export const REPORT_REASON_CODES = [
  "SCAM",
  "FALSE",
  "INAPPROPRIATE",
  "UNAVAILABLE",
  "OTHER",
  "NONE"
] as const;

export interface AdReportReason {
  code: (typeof REPORT_REASON_CODES)[number];
  title: string;
}

export const REPORT_REASONS: Array<AdReportReason> = [
  { code: "SCAM", title: "Scam, spam or misleading" },
  { code: "FALSE", title: "Incorrect information" },
  { code: "INAPPROPRIATE", title: "Inappropriate content" },
  { code: "UNAVAILABLE", title: "No longer available" },
  { code: "OTHER", title: "Other" },
];

export const AD_REPORT_SCHEMA = CASE_SCHEMA.extend({
  reason: z.enum(REPORT_REASON_CODES),
  details: z.string(),
  email: z.string(),
  name: z.string(),
});

export type AdReportCase = z.infer<typeof AD_REPORT_SCHEMA>;
